import HomeIcon from "../assets/icons/sidebar/HomeIcon";
import AccountIcon from "../assets/icons/sidebar/AccountIcon";
import ShopIcon from "../assets/icons/sidebar/ShopIcon";
import ReportsIcon from "../assets/icons/sidebar/ReportsIcon";
import StructureIcon from "../assets/icons/sidebar/StructureIcon";
import WalletIcon from "../assets/icons/sidebar/WalletIcon";
import EducationIcon from "../assets/icons/sidebar/EducationIcon";
import ProfileIcon from "../assets/icons/sidebar/ProfileIcon";
import NewsIcon from "../assets/icons/sidebar/NewsIcon";
import InfoIcon from "../assets/icons/sidebar/InfoIcon";
import SettingsIcon from "../assets/icons/sidebar/SettingsIcon";
import CartIcon from "../assets/icons/sidebar/CartIcon";
import { useTranslation } from "react-i18next";

export const useNavLinks = () => {
  const { t } = useTranslation();
  return [
    { name: t("home"), path: "/main", icon: <HomeIcon /> },
    {
      name: t("account"),
      path: "/main/account",
      icon: <AccountIcon />,
    },
    // { name: t("shop"), path: "/main/shop", icon: <ShopIcon /> },
    // {
    //   name: t("orders"),
    //   path: "/main/orders",
    //   icon: <CartIcon />,
    // },
    // {
    //   name: t("structure"),
    //   path: "/main/structure",
    //   icon: <StructureIcon />,
    // },
    // {
    //   name: t("wallet"),
    //   path: "/main/wallet",
    //   icon: <WalletIcon />,
    // },
    // {
    //   name: t("reports"),
    //   path: "/main/reports",
    //   icon: <ReportsIcon />,
    // },
    // {
    //   name: t("education"),
    //   path: "/main/education",
    //   icon: <EducationIcon />,
    // },
    {
      name: t("profile"),
      path: "/main/profile",
      icon: <ProfileIcon />,
    },
    // { name: t("news"), path: "/main/news", icon: <NewsIcon /> },
    // { name: t("faq"), path: "/main/faq", icon: <InfoIcon /> },
    // {
    //   name: t("adminPanel"),
    //   path: "/main/admin",
    //   icon: <SettingsIcon />,
    // },
  ];
};
